import { jwtDecode } from 'jwt-decode';
import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));
    const [user, setUser] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const rememberMe = localStorage.getItem('rememberMe') === 'true';

        if (token) {
            const decodedToken = jwtDecode(token);
            const currentTime = Date.now() / 1000;

            // Si "Remember Me" está activo, extender el tiempo de gracia
                const gracePeriod = rememberMe ? 86400 : 0; // 24 horas extra

            if (decodedToken.exp + gracePeriod < currentTime) {
                logout();
            } else {
                setUser(decodedToken.user); // Suponiendo que el payload tiene un 'user'
                setIsLoggedIn(true);
            }
        }
    }, []);

    const login = (token, user, rememberMe = false) => {
        localStorage.setItem('token', token);
        localStorage.setItem('rememberMe', rememberMe);
        setUser(user);
        setIsLoggedIn(true);
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('rememberMe');
        setUser(null);
        setIsLoggedIn(false);
    };

    return (
        <AuthContext.Provider value={{ isLoggedIn, login, logout, user }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
